<div>
  <div class="modal-header">
    <h3>Add New {{ meta.verbose_name }} </h3>
  </div>
  <div class="modal-body" style="padding-right:10px;" *ngIf="meta.fields">
    <app-dynamic-input *ngFor="let key of filteredFields"
                       [meta]="meta" [(item)]="item" [key]="key"></app-dynamic-input>

    <!-- Use the above to filter out display fields that are not needed.
    We just want to see the specify relationship type field(s)
    The remaining fields are displayed below -->
    <div>
      <app-dynamic-input *ngFor="let key of ['contact_type']"
                         [meta]="meta" [(item)]="item" [key]="prefix+key"></app-dynamic-input>

      <div *ngIf="item[prefix+'contact_type'] === 'individual'">
        <app-dynamic-input *ngFor="let key of ['first_name', 'last_name', 'title', 'contact_uin', 'division_name']"
                           [meta]="meta" [(item)]="item" [key]="prefix+key"></app-dynamic-input>

      </div>
      <div *ngIf="item[prefix+'contact_type'] === 'organization'">
        <app-dynamic-input
          *ngFor="let key of ['org_name', 'org_type', 'org_uin', 'duns_number', 'org_ein', 'state_business_id', 'owner_percent']"
          [meta]="meta" [(item)]="item" [key]="prefix+key"></app-dynamic-input>

      </div>
      <div>
        <app-dynamic-input
          *ngFor="let key of ['phone_number', 'alternate_phone', 'fax_number', 'email_address', 'address_line_1',
                         'address_line_2','city', 'state', 'zip_code', 'country', 'source_of_data' ]"
          [meta]="meta" [(item)]="item" [key]="prefix+key"></app-dynamic-input>

      </div>

    </div>

  </div>
  <div class="modal-footer">
    <button class="btn btn-default" *ngIf="!saving" (click)="cancel()">Cancel</button>
    <button class="btn btn-primary"
            *ngIf="meta.add_another_reset !== undefined && item[prefix+'globalid'] === undefined"
            [disabled]="saving" (click)="submit(true)">
      <span *ngIf="!saving">Submit and Add Another</span>
      <span *ngIf="saving"><i class="fa fa-spinner fa-pulse"></i></span>
    </button>
    <button class="btn btn-primary" [disabled]="saving" (click)="submit(false)">
      <span *ngIf="!saving">Submit</span>
      <span *ngIf="saving"><i class="fa fa-spinner fa-pulse"></i></span>
    </button>
  </div>
</div>
